import React from 'react';
import styled from '@emotion/styled';
import { InteractiveRemote } from './InteractiveRemote';
import { RemoteShortcutsInfo } from './RemoteShortcutsInfo';

export const Remote = () =>
  <RemoteContainer>
    <InteractiveRemote/>
    <RemoteShortcutsInfo/>
  </RemoteContainer>;

const RemoteContainer = styled.div`
    top: -3%;
    position: relative;
    width: 25%;
    height:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
